// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3IIOO","loaderOuter":"PageOverlayLoader_loaderOuter__3rie3"};